export default window.__locale__ || {
  locale: 'en',
  isDummyLocale: false,
  localeData: null,
  messages: {},
};
